import { Alert, Button, Modal } from "react-bootstrap";

export type ConfirmProps = {
    confirmInfo?: ConfirmInfo 
}

export type ConfirmInfo = {
    text: string,
    onConfirmCallback: () => void,
    onAbortCallback: () => void
}

function Confirm(props: ConfirmProps) {

    return (<Modal show={props.confirmInfo !== undefined}><Modal.Body><Alert key='info' variant='warning'>
        {props.confirmInfo?.text}
    </Alert>
    </Modal.Body>
        <Modal.Footer>
            <Button variant="danger" onClick={props.confirmInfo?.onConfirmCallback} >OK</Button>
            <Button variant="secondary" onClick={props.confirmInfo?.onAbortCallback} >Abbrechen</Button>
        </Modal.Footer>
    </Modal>)
}
export default Confirm;